import tippy from 'tippy.js';
//import 'tippy.js/dist/tippy.css';

console.log("----- tool tip script loaded -----");

tippy('[data-tippy-content]', {
    interactive: true,
    appendTo: 'parent',
    placement: 'right',
    animation: 'fade',
    theme: "custom",
});


